<script lang="ts" setup>
	import { OTP } from 'vue3-otp-input-field'

	withDefaults(
		defineProps<{
			value: string
			maxInput?: number
		}>(),
		{
			maxInput: 4
		}
	)
	const emits = defineEmits<{
		(arg: 'update:value', param: string | number): void
	}>()

	const getValue = (param: string[]) => {
		if (Array.isArray(param)) {
			const result = param.join('')
			emits('update:value', result)
		}
	}
</script>

<template>
	<div>
		<OTP
			size="medium"
			class-name="otp-input"
			:fields="maxInput"
			type="mix"
			inputstyle="height: 60px !important; max-width: 60px; font-size: 20px !important; "
			placeholder="*"
			autofocus
			@o-t-p-value-changed="e => getValue(e as unknown as string[])"
		/>
	</div>
</template>

<style scoped>
	.otp-input {
		@apply items-center rounded-lg border border-gray-200 bg-gray-25 text-center focus-visible:!outline-gray-200;
	}
</style>
